// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/authentication/components/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import CheckingAuth from "layouts/authentication/components/CheckingAuth";
import MyDetails from "layouts/profile/components/myDetails";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import LinktoAnothers from "layouts/profile/components/LinktoAnothers";
import GlobalChat from "layouts/profile/components/GlobalChat";
import WhatsAppChat from "layouts/profile/components/WhatsAppChat";
import AdminChapterManager from "./layouts/authentication/components/AdminChapterManager";
import AdminNavBar from "./layouts/authentication/components/AdminNavBar";
import AdminImportStudentDetails from "./layouts/authentication/components/AdminImportStudentDetails";
// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/dashboard",
  //   component: <Dashboard />,
  // },
  {
    type: "collapse",
    name: "MyDetails",
    key: "MyDetails",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/MyDetails",
    component: <MyDetails />,
  },
  {
    type: "collapse",
    name: "Link to Others",
    key: "LinktoAnothers",
    icon: <Icon fontSize="small">book</Icon>,
    route: "/LinktoAnothers",
    component: <LinktoAnothers />,
  },
  {
    type: "collapse",
    name: "Global Chat",
    key: "GlobalChat",
    icon: <Icon fontSize="small">chat</Icon>,
    route: "/GlobalChat",
    component: <GlobalChat />,
  },
  {
    type: "collapse",
    name: "Chat",
    key: "Chat",
    icon: <Icon fontSize="small">message</Icon>,
    route: "/Chat",
    component: <WhatsAppChat />,
  },
  
  // Uncomment as needed:

  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Auth Check",
  //   key: "auth-check",
  //   icon: <Icon fontSize="small">verified_user</Icon>,
  //   route: "/BasicAuth",
  //   component: <CheckingAuth />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign In",
  //   key: "sign-in",
  //   icon: <Icon fontSize="small">login</Icon>,
  //   route: "/authentication/sign-in",
  //   component: <SignIn />,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">person_add</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  //   hidden: true,
  // },
  {
    path: "/admin/chapters",
    element: (
      <>
        <AdminNavBar />
        <AdminChapterManager />
      </>
    ),
  },
];

export default routes;
